@let jobs = uploadMgr.jobs$ | async;
@if (jobs && jobs.length > 0) {
  <div class="upload-status" [class.collapsed]="collapsed">
    <header class="upload-status-header" (click)="toggle()">
      <div class="header-text">
        @if (activeCount(jobs); as n) {
          <span>Uploading {{ n }} {{ n === 1 ? 'file' : 'files' }}</span>
        } @else {
          <span>Uploads</span>
        }
      </div>
      <div class="header-actions">
        @if (hasFinished(jobs) && !collapsed) {
          <button class="link-btn" type="button" (click)="$event.stopPropagation(); uploadMgr.dismissAllFinished()">
            Clear finished
          </button>
        }
        <button class="icon-btn" type="button" [attr.aria-label]="collapsed ? 'Expand' : 'Collapse'">
          <i class="pi" [class.pi-chevron-up]="!collapsed" [class.pi-chevron-down]="collapsed"></i>
        </button>
      </div>
    </header>

    @if (!collapsed) {
      <ul class="upload-list">
        @for (job of jobs; track job.id) {
          <li class="upload-row" [attr.data-status]="job.status">
            <div class="upload-row-top">
              <span class="filename" [title]="job.fileName">{{ job.fileName }}</span>
              <span class="status">
                @switch (job.status) {
                  @case ('success') { <i class="pi pi-check-circle"></i> }
                  @case ('error') { <i class="pi pi-exclamation-circle"></i> }
                }
                {{ statusLabel(job) }}
              </span>
              @if (isFinished(job)) {
                <button class="dismiss-btn" type="button" (click)="uploadMgr.dismissJob(job.id)" aria-label="Dismiss">
                  <i class="pi pi-times"></i>
                </button>
              }
            </div>
            @if (isActive(job)) {
              <div class="progress-track">
                <div class="progress-fill" [style.width.%]="job.progress"></div>
              </div>
            }
            @if (job.status === 'error' && job.errorMessage) {
              <div class="error-text">{{ job.errorMessage }}</div>
            }
          </li>
        }
      </ul>
    }
  </div>
}
